/**
 * Copy da vitrine das Automações. Os nomes dos blocos do Touch Builder são os da paleta real (Início, Agente IA, Criar
 * Negócio, Transferir, Tarefa, Pesquisa). Resumo, PDF e e-mail só existem nos pacotes a partir de 5.000 execuções.
 */
const ASSETS = '/assets';

export default {
    title: 'Automações',
    art: 'as Automações',
    heroTitle: ['Monte a automação ligando blocos.', 'Ela trabalha sozinha.'],
    summary:
        'O Touch Builder é o editor visual da plataforma. Cada bloco é uma ação, como responder o cliente, criar um cartão no CRM ou agendar uma tarefa. Você liga os blocos e publica.',
    stripLabel: 'Conecta',
    strip: [
        { name: 'WhatsApp', logo: `${ASSETS}/whatsapp_icon.svg` },
        { name: 'AdvBox', logo: `${ASSETS}/advbox.svg` },
        { name: 'ControlJUS', logo: null },
        { name: 'E-mail', logo: `${ASSETS}/gmail_icon.svg` },
    ],
    painTitle: 'O cliente escreve à noite e só recebe resposta de manhã.',
    before: 'O cliente escreve à noite e ninguém responde até o dia seguinte. Depois, alguém copia os dados dele para o CRM à mão.',
    after: 'O agente de IA responde na hora, o cartão no CRM nasce sozinho e, se o cliente preferir, a conversa vai para uma pessoa da equipe.',
    demoTitle: 'Veja o Touch Builder montando uma automação.',
    demoSub: 'Role a página. O fluxo é montado bloco por bloco, como na ferramenta.',
    glossary: [
        { term: 'Touch Builder', def: 'O editor visual onde você monta a automação ligando blocos.', icon: 'flow' },
        { term: 'Bloco', def: 'Uma ação, como responder o cliente ou criar um cartão no CRM.', icon: 'layers' },
        { term: 'Agente IA', def: 'Uma inteligência artificial que conversa com o cliente.', icon: 'bot' },
        { term: 'Publicar', def: 'Ligar o fluxo para ele passar a funcionar sozinho.', icon: 'send' },
    ],
    videoTitle: 'O Touch Builder, no sistema real.',
    poster: `${ASSETS}/showcase/touch-builder-fluxo.webp`,
    chapters: ['Montar os blocos', 'Ligar os caminhos', 'Publicar'],
    exTitle: 'Abra o fluxo e veja cada bloco.',
    exSub: 'Este é um fluxo real do Touch Builder. Escolha um bloco e a peça sai da tela.',
    groups: [
        { title: 'Montar', items: ['Touch Builder, editor visual', 'Agente de IA no fluxo', 'Blocos de CRM, tarefa e pesquisa', 'Webhooks e requisições HTTP'] },
        {
            title: 'Agendar',
            items: [
                'Tarefas recorrentes com dia e hora',
                'Pacotes AdvBox e ControlJUS, de 1.000 a 50.000 execuções por mês',
                'Resumo, PDF e e-mail a partir de 5.000 execuções',
            ],
        },
        { title: 'Acompanhar', items: ['Histórico de execuções', 'Fluxo publicado atende a qualquer hora', 'Passagem para a equipe no Inbox'] },
    ],
    steps: [
        { title: 'Experimente', body: 'Libere as Automações e abra o Touch Builder.' },
        { title: 'Monte o fluxo', body: 'Arraste os blocos e ligue os caminhos.' },
        { title: 'Publique', body: 'Ligue o fluxo para ele atender sozinho e acompanhe cada execução.' },
    ],
    extraFaq: {
        q: 'O que é o Touch Builder?',
        a: 'É o editor visual da plataforma, onde você monta a automação ligando blocos. Cada bloco faz uma ação, e você publica quando o fluxo estiver pronto.',
    },
    finalTitle: 'Deixe a rotina por conta da plataforma.',
    finalBullets: ['Fluxos no Touch Builder, com agente de IA', 'Cartão no CRM criado sozinho', 'Passagem para a equipe quando o cliente pede'],
};
